import PopupPriceGroup from './PopupPriceGroup.vue'
import { type ComponentInstance, isEmptyObject } from '@/components/utils'
import { mountComponent, usePopupState } from '@/components/utils/mount-component'

import {
  type PriceGroupCallback, type showPopupPriceGroupOption,
} from './types'

import { OrderType, type PriceInfo, type ProductSpecColorInfo, type SpecGroup } from '../../types'
import { getMinQty, getPriceList, getSpecListByPriceList, getTotalQty, usePriceGroup, useWindow } from '../../composables'
import { h, reactive } from 'vue'
import { getSelectedValue, mapSpecLimitation } from './utils'
import { useProductSpec } from '../../store/modules/productSpec'
import { useSpec } from '../../store/modules/spec'
import { useAddon } from '../../store/modules/addon'
import { useImprintMethod } from '../../store/modules/imprintMethod'
import { useApp } from '../../store/modules/app'
import { ImprintMethodModel, ProductSpecModel } from '../../model'
import { useUpdateView } from '../../composables/use-update'
import { ApMessageBox } from '@anypromo/components-pc'

let instance: ComponentInstance

function initInstance () {
  const Wrapper = {
    setup () {
      const { state, toggle } = usePopupState()

      console.log('initInstance initInstance')

      return () => h(PopupPriceGroup, {
        ...state,
        'onUpdate:visible': toggle
      })
    }
  };

  ({ instance } = mountComponent(Wrapper))
}

/**
 * 关闭对话框
 */
function hideDialog (): void {
  if (instance) {
    instance.toggle(false)
  }
}

// /**
//  *
//  * @param {any} spec
//  * @param {any} all 是否返回所有可用的values
//  */
// function getSelectedValue (options: PriceGroupCallback, spec: SpecGroup, all = false): string[] {
//   const specName = spec.name
//   let selectedValues = []

//   const specLimitation = options.selectedItem!.specLimitation
//   const findItem = specLimitation?.find(f => f.name === specName)
//   if (!findItem) return spec.values.map(f => f.value)
//   if (specLimitation && specLimitation.findIndex(f => f.name === specName) !== -1) {
//     if ((['productSpec', 'spec', 'addon'].includes(options.type)) && specName === options.value.name) {
//       if (findItem?.values.some(function (it) { return it === options.value.value })) {
//         selectedValues.push(options.value.value)
//       } else {
//         selectedValues = findItem?.values ?? []
//       }
//     } else {
//       selectedValues = findItem.values
//     }
//   } else {
//     if ((['productSpec', 'spec', 'addon'].includes(options.type)) && specName === options.value.name) {
//       selectedValues.push(options.value.value)
//     } else {
//       spec.values.some((it: any) => {
//         if (it.value !== '-1') {
//           selectedValues.push(it.value)
//           return !all
//         }
//         return false
//       })
//     }
//   }
//   return selectedValues
// }


const getOldPriceList = () => {
  const {
    productSpecList,
    specList,
    addonList,
  } = useWindow()

  const appState = useApp();
  const productSpecListState = useProductSpec()
  const specState = useSpec();
  const addonState = useAddon();
  const imprintMethodState = useImprintMethod()

  // 重新计算price list
  const priceList = getPriceList({
    isBlank: appState.getBlankValue,
    productSpecList: productSpecListState.getSelectedList,
    specList: specState.getSelectedList,
    addonList: addonState.getSelectedList,
    imprintMethodList: imprintMethodState.getSelectedList
  })

  /* 判断step 1里的值有没有限制 */
  let isProductSpecLimitation = false
  let isSpecLimitation = false
  let isAddonLimitation = false

  const totalQty = getTotalQty(productSpecListState.getSelectedList)
  const specLimitation = getSpecListByPriceList(priceList, productSpecList, specList, addonList)


  if (productSpecList.length > 0) {
    // 如果有product spec分组
    isProductSpecLimitation = productSpecList.some((spec) => {
      // 如果用户不是选择price group，说明是要切换，一般都是imprint/blank之间的切换
      // 从price list里判断是否都满足条件
      if (specLimitation[spec.name]) {
        const spValues = specLimitation[spec.name]
        if (spValues) {
          // 判断当前所选的value是否都在里面
          if (productSpecListState.getSelectedList.every(f => {
            const selectedValue = f.productSpec.find(sp => sp.name === spec.name)
            if (selectedValue) {
              if (spValues.includes(selectedValue.value.value)) {
                return true
              }
            }
            return false
          })) {
            return false
          }
          return true
        }
      }

      return false
    })
  }

  if (specList.length > 0) {
    // 如果有spec分组
    isSpecLimitation = specList.some((spec) => {
      if (specLimitation[spec.name]) {
        const spValues = specLimitation[spec.name]

        // 判断spec 是否都满足
        const sp = specState.getSelectedList.find(f => f.name === spec.name)
        if (sp && sp.selectedItem) {
          // 如果所选的spec,没有在price里
          if (spValues.includes(sp.selectedItem.value) === false) {
            return true
          }
        }
      }
      return false
    })
  }

  if (addonList.length > 0) {
    // 如果有addon分组
    isAddonLimitation = addonList.some((spec) => {
      if (specLimitation[spec.name]) {
        const spValues = specLimitation[spec.name]

        // 判断spec 是否都满足
        const sp = addonState.getSelectedList.find(f => f.name === spec.name)
        if (sp && sp.selectedItem) {
          // 如果所选的spec,没有在price里
          if (spValues.includes(sp.selectedItem.value) === false) {
            return true
          }
        }
      }
      return false
    })
  }

}

/**
 * 判断是否显示Price Group
 * @param options
 */
const showPopupPriceGroup = (options: showPopupPriceGroupOption): void => {
  if (!instance) {
    initInstance()
  }
  const {
    productSpecList,
    specList,
    addonList,
  } = useWindow()

  const dataOptions = usePriceGroup(options)


  instance.open(Object.assign({
    visible: true,
  },
    dataOptions, {
    callback: (data: PriceGroupCallback) => {
      // console.log('PriceGroupCallback', data)
      // 如果有对话框数据，说明是弹窗的
      const productSpecNum = productSpecList.length

      /**
       * 先计算老的price list
       */
      // getOldPriceList();

      if (options.type === 'productSpec' && (productSpecNum === 0)) {
        // hideDialog()
        return
      }

      const appState = useApp();
      const productSpecListState = useProductSpec()
      const specState = useSpec();
      const addonState = useAddon();
      const imprintMethodState = useImprintMethod()



      if (data.type === 'switch' || data.updateBlankValue) {
        data.changedStep.imprintMethod = true;
        appState.setBlankValue(!appState.getBlankValue)
      }


      let priceList: PriceInfo[] = []
      if (data.selectedItem) {
        priceList = data.selectedItem.priceList
      } else {
        // 重新计算price list
        priceList = getPriceList({
          isBlank: appState.getBlankValue,
          productSpecList: productSpecListState.getSelectedList,
          specList: specState.getSelectedList,
          addonList: data.type === 'addon' ? addonState.getSelectedList.map(f => {
            return {
              name: f.name,
              text: f.text,
              selectedItem: f.name === data.value.name ? addonList.find(addon => addon.name === f.name)?.values.find(val => val.value === data.value.value) : f.selectedItem
            }
          }) : addonState.getSelectedList,
          imprintMethodList: imprintMethodState.getSelectedList
        })


        // 如果目前数据没有满足，那就重新计算price list
        if (priceList.length === 0) {

          // 如果是切换imprint/blank，那只能根据isblank值计算price
          if (data.type === 'switch' || data.updateBlankValue) {

            priceList = getPriceList({
              isBlank: appState.getBlankValue,
              productSpecList: [],
              specList: data.type === 'spec' ? specList.map(f => {

                return {
                  name: f.name,
                  text: f.text,
                  selectedItem: f.name === data.value.name ? f.values.find(val => val.value === data.value.value) : undefined
                }
              }) : [],
              addonList: data.type === 'addon' ? addonList.map(f => {
                return {
                  name: f.name,
                  text: f.text,
                  selectedItem: f.name === data.value.name ? f.values.find(val => val.value === data.value.value) : undefined
                }
              }) : [],
              imprintMethodList: []
            })

          } else if (data.type === 'method') {
            const m = new ImprintMethodModel()
            m.decorationMethod = data.value.method!
          }
        }
      }


      // 根据price list重新生成限制
      const selectedProductSpecList = options.productSpecList ?? productSpecListState.getSelectedList
      const specLimitation = getSpecListByPriceList(priceList, productSpecList, specList, addonList)

      /* 判断step 1里的值有没有限制 */
      let isProductSpecLimitation = false
      let isSpecLimitation = false
      let isAddonLimitation = false

      const totalQty = getTotalQty(selectedProductSpecList)

      let tmpQty = 0;
      if (selectedProductSpecList.length > 0) {
        tmpQty = selectedProductSpecList[0].getQty();
      }

      if (productSpecNum > 0) {
        // 如果有product spec分组
        if (options.type === 'productSpec') {
          isProductSpecLimitation = true
        } else {
          isProductSpecLimitation = productSpecList.some((spec) => {
            if (data.selectedItem) {
              if (data.selectedItem.specLimitation) {
                const spValues = data.selectedItem.specLimitation.find(sp => sp.name === spec.name)
                if (spValues) {
                  // 如果spec limitation有值，说明有限制

                  // 判断当前所选的value是否都在里面
                  if (selectedProductSpecList.every(f => {
                    const selectedValue = f.productSpec.find(sp => sp.name === spec.name)
                    if (selectedValue) {
                      if (spValues.values.includes(selectedValue.value.value)) {
                        return true
                      }
                    }
                    return false
                  })) {
                    return false
                  }
                  return true
                }
              }
            } else {
              // 如果用户不是选择price group，说明是要切换，一般都是imprint/blank之间的切换
              // 从price list里判断是否都满足条件
              if (specLimitation[spec.name]) {
                const spValues = specLimitation[spec.name]
                if (spValues) {
                  // 判断当前所选的value是否都在里面
                  if (selectedProductSpecList.every(f => {
                    const selectedValue = f.productSpec.find(sp => sp.name === spec.name)
                    if (selectedValue) {
                      if (spValues.includes(selectedValue.value.value)) {
                        return true
                      }
                    }
                    return false
                  })) {
                    return false
                  }
                  return true
                }
              }
            }
            return false
          })
        }
      }


      if (specList.length > 0) {
        // 如果有spec分组
        isSpecLimitation = specList.some((spec) => {
          if (data.selectedItem) {
            if (data.selectedItem.specLimitation) {
              if (data.selectedItem.specLimitation.findIndex(sp => sp.name === spec.name) !== -1) {
                // 如果spec limitation有值
                return true
              }
            }
          } else {
            if (specLimitation[spec.name]) {
              const spValues = specLimitation[spec.name]

              // 判断spec 是否都满足
              const sp = specState.getSelectedList.find(f => f.name === spec.name)
              if (sp && sp.selectedItem) {
                // 如果所选的spec,没有在price里
                if (spValues.includes(sp.selectedItem.value) === false) {
                  return true
                }
              }
            }

          }
          return false
        })
      }

      if (addonList.length > 0) {
        // 如果有addon分组
        isAddonLimitation = addonList.some((spec) => {
          if (data.selectedItem) {
            if (data.selectedItem.specLimitation) {
              if (data.selectedItem.specLimitation.findIndex(sp => sp.name === spec.name) !== -1) {
                // 如果spec limitation有值
                return true
              }
            }
          } else {
            if (specLimitation[spec.name]) {
              const spValues = specLimitation[spec.name]

              // 判断spec 是否都满足
              const sp = addonState.getSelectedList.find(f => f.name === spec.name)
              if (sp && sp.selectedItem) {
                // 如果所选的spec,没有在price里
                if (spValues.includes(sp.selectedItem.value) === false) {
                  return true
                }
              }
            }

          }
          return false
        })
      }

      const { selectedItem } = data;

      if (imprintMethodState.getSelectedList.length > 0 && appState.getBlankValue === false) {
        if (selectedItem) {
          for (let i = imprintMethodState.getSelectedList.length - 1; i >= 0; i--) {
            const item = imprintMethodState.getSelectedList[i]
            if (selectedItem.imprintMethodLimitation.length > 0 && selectedItem.imprintMethodLimitation.includes(item.decorationMethod.Method) === false) {
              // selectedImprintMethodList.splice(i, 1)
              imprintMethodState.removeAt(i)
              data.changedStep.imprintMethod = true;
            }
          }
        }
      }


      useUpdateView({
        isBlank: appState.getBlankValue,
        selectedProductSpecList: productSpecListState.getSelectedList,
        selectedSpecList: specState.getSelectedList,
        selectedAddonList: addonState.getSelectedList,
        selectedImprintMethodList: imprintMethodState.getSelectedList,
        priceList: priceList
      })

      // 判断当前所选的addon limitation是否满足条件
      if (isAddonLimitation) {
        if (selectedItem) {
          addonState.getSelectedList.forEach(addon => {
            const sp = selectedItem.specLimitation.find(s => s.name === addon.name)
            if (!sp) return

            if (addon.selectedItem) {
              if (sp.values.includes(addon.selectedItem.value) === false) {
                addon.selectedItem = undefined
                data.changedStep.addon = true;
              }
            } else if (data.type === 'addon') {
              // 自动选中
              addon.selectedItem = addon.values.find(val => val.value === data.value.value)
            }
          })
        } else {
          addonState.getSelectedList.forEach(spec => {
            if (!spec.selectedItem) return
            if (specLimitation[spec.name]) {
              const specValues = specLimitation[spec.name]
              if (specValues.includes(spec.selectedItem.value) === false) {
                spec.selectedItem = undefined
                data.changedStep.addon = true;
              }
            }
          })
        }
      } else {
        // 如果当前满足，但是用户选择的是addon，就要切换到用户所选的
        if (data.type === 'addon') {
          addonState.getSelectedList.some(item => {
            if (item.name === data.value.name) {
              // 查找
              // 查找value
              const value = item.values.find(val => val.value === data.value.value)
              if (value && value.enabled) {
                item.selectedItem = value
              }

              return true
            }
            return false
          })
        }
      }

      useUpdateView({
        isBlank: appState.getBlankValue,
        selectedProductSpecList: productSpecListState.getSelectedList,
        selectedSpecList: specState.getSelectedList,
        selectedAddonList: addonState.getSelectedList,
        selectedImprintMethodList: imprintMethodState.getSelectedList,
        priceList: priceList
      })

      // 判断当前所选的spec limitation是否满足条件
      if (isSpecLimitation) {
        if (selectedItem) {
          specState.getSelectedList.forEach(spec => {
            const sp = selectedItem.specLimitation.find(s => s.name === spec.name)
            if (!sp) return

            if (spec.selectedItem) {
              if (sp.values.includes(spec.selectedItem.value) === false) {
                spec.selectedItem = undefined
                data.changedStep.spec = true;
              }
            } else if (data.type === 'spec') {
              // 自动选中
              spec.selectedItem = spec.values.find(val => val.value === data.value.value)
            }
          })
        } else {
          specState.getSelectedList.forEach(spec => {
            if (!spec.selectedItem) return
            if (specLimitation[spec.name]) {
              const specValues = specLimitation[spec.name]
              if (specValues.includes(spec.selectedItem.value) === false) {
                spec.selectedItem = undefined
                data.changedStep.spec = true;
              }
            }
          })
        }
      } else {
        // 如果当前满足，但是用户选择的是addon
        if (data.type === 'spec') {
          specState.getSelectedList.some(spec => {
            if (spec.name === data.value.name) {
              // 查找
              // 查找value
              const value = spec.values.find(val => val.value === data.value.value)
              if (value && value.enabled) {
                spec.selectedItem = value
                data.changedStep.spec = true;
              }

              return true
            }
            return false
          })
        }
      }


      appState.updatePriceList();
      useUpdateView({
        isBlank: appState.getBlankValue,
        selectedProductSpecList: productSpecListState.getSelectedList,
        selectedSpecList: specState.getSelectedList,
        selectedAddonList: addonState.getSelectedList,
        selectedImprintMethodList: imprintMethodState.getSelectedList,
        priceList: appState.getCurrentPriceList
      })

      // 判断
      if (isProductSpecLimitation) {
        if (options.type === 'switch') {
          const isSingle = productSpecListState.getSelectedList.length === 1;
          let oldObj: ProductSpecModel | undefined = undefined;
          if (isSingle) {
            oldObj = productSpecListState.getSelectedList[0]
          }
          // 如果是切换的话，那就删除不满足条件的product spec
          for (let i = productSpecListState.getSelectedList.length - 1; i >= 0; i--) {
            const item = productSpecListState.getSelectedList[i];
            //
            const flag = item.productSpec.every(spec => {
              // const specName = spec.name
              if (specLimitation[spec.name]) {
                const spValues = specLimitation[spec.name]

                //判断当前所选的value是否在列表里，如果不在列表里，说明不支持，就必须删除。
                if (spValues.includes(spec.value.value) === false) {
                  // productSpecListState.removeAt(i);
                  return false;
                }
              }
              return true;
            })
            if (flag === false) {
              data.changedStep.productSpec = true;
              productSpecListState.removeAt(i);
            }
          }
          if (isSingle) {
            //修改被删除的
            if (oldObj) {
              oldObj.productSpec.forEach((spec) => {
                if (specLimitation[spec.name]) {
                  const spValues = specLimitation[spec.name]
                  if (spValues.includes(spec.value.value) === false) {
                    const ps = productSpecList.find(f => f.name === spec.name);
                    if (ps) {
                      const value = ps.values.find(val => val.value === spValues[0])

                      if (value) {
                        if (oldObj) {
                          data.changedStep.productSpec = true;
                          oldObj.setValue(spec.name, value)
                        }
                      }
                    }
                  }
                }
              })
              productSpecListState.add(oldObj)
            }
          }

        } else if (selectedItem) {
          for (let i = productSpecListState.getSelectedList.length - 1; i >= 0; i--) {
            const item = productSpecListState.getSelectedList[i]
            const isMatch = item.productSpec.every(it => {
              const sp = selectedItem.specLimitation.find(s => s.name === it.name)
              if (!sp) return true

              if (sp.values.includes(it.value.value) === false) {
                return false
              }
              return true
            })

            if (!isMatch) {
              data.changedStep.productSpec = true;
              // 删除
              productSpecListState.removeAt(i);
            }
          }
        } else if (data.value && appState.getMaxAssortNum === 1) {
          const specName = data.value.name;
          const ps = productSpecList.find(f => f.name === specName);


          if (ps) {
            productSpecListState.getSelectedList.some(spGroup => {
              const spec = spGroup.productSpec.find(f => f.name === specName);
              if (spec) {
                // 查找value
                const value = ps.values.find(val => val.value === data.value.value)
                if (value) {
                  spGroup.setValue(specName, value)
                }
                return true
              }
              return false
            })
          }
        }
      }


      if (data.changedStep.productSpec) {
        // 如果是在step 1上点击，那说明要添加新的
        if (data.selectedItem) {
          if (productSpecListState.getSelectedList.length === 0) {
            const _tmpProductSpecList: ProductSpecColorInfo[] = []
            // 计算单价
            productSpecList.forEach(function (spec) {
              if (spec.values.length === 1) {
                _tmpProductSpecList.push({ name: spec.name, value: spec.values[0] })
              } else {
                const selectedValues = getSelectedValue(data, spec)

                for (let j = 0; j < spec.values.length; j++) {
                  if (selectedValues.includes(spec.values[j].value)) {
                    _tmpProductSpecList.push({ name: spec.name, value: spec.values[j] })
                    break
                  }
                }
              }
            })

            const minQty = options.orderType == OrderType.SpecSample ? 1 : data.selectedItem.minQty;

            const editObj = new ProductSpecModel()
            editObj.objectId = 0
            editObj.setProductSpec(_tmpProductSpecList)
        
            // 如果是多size商品，那就先把原来的数量清掉
            if (Array.isArray(editObj.quantity)) {
            }else{
              if (tmpQty > 0 && minQty) {
                tmpQty = Math.max(tmpQty, minQty)
              } else if (minQty > 0) {
                tmpQty = minQty
              } 
              editObj.setQty(tmpQty)
            }   

            // 添加到页面上
            productSpecListState.add(editObj)
          }
        }
      } else {
        // 检查数量
        const imprintMethodList = [...imprintMethodState.getSelectedList]
        if (options.type === 'method') {
          const index = imprintMethodList.findIndex(f => f.decorationMethod.Location === options.value.method!.Location)
          if (index !== -1) {
            imprintMethodList.splice(index, 1);
          }
          // 然后添加新的imprint method
          const newImprint = new ImprintMethodModel()
          newImprint.decorationMethod = options.value.method!

          imprintMethodList.push(newImprint)

        }

        const minQty = getMinQty(priceList, imprintMethodList, true)
        if (totalQty < minQty) {
          // 如果数量不满足，那说明step 1要还
          data.changedStep.productSpec = true;
          if (productSpecListState.getSelectedList.length === 1) {
            if (Array.isArray(productSpecListState.getSelectedList[0].quantity)) {

            } else {
              // 自动帮用户改成最小数量
              productSpecListState.getSelectedList[0].quantity.quantity = minQty;
            }
          }
        }
      }

      if (data.changedStep.spec) {
        if (selectedItem) {
          if (options.type === 'spec') {
            specState.getSelectedList.forEach(item => {
              // 先判断所有的是否都满足条件
              specList.forEach((spec) => {
                if (spec.name === item.name) {
                  const selectedValues = getSelectedValue(data, spec, true)
                  if (selectedValues.length === 1) {
                    item.selectedItem = spec.values.find(val => val.value === selectedValues[0])
                  } else {
                    if (item.selectedItem && selectedValues.includes(item.selectedItem?.value)) {
                      return
                    }
                    item.selectedItem = undefined
                  }
                }
              })
            })
          }
        } else {

        }
      }

      if (data.changedStep.addon) {
        if (selectedItem) {
          if (options.type === 'addon') {
            addonState.getSelectedList.forEach(item => {
              // 先判断所有的是否都满足条件
              addonList.forEach((spec) => {
                if (spec.name === item.name) {
                  const selectedValues = getSelectedValue(data, spec, true)
                  if (selectedValues.length === 1) {
                    item.selectedItem = spec.values.find(val => val.value === selectedValues[0])
                  } else {
                    if (item.selectedItem && selectedValues.includes(item.selectedItem?.value)) {
                      return
                    }
                    item.selectedItem = undefined
                  }
                }
              })
            })
          }

        } else {
          //
          if (options.type === 'addon') {
            addonState.getSelectedList.forEach(item => {
              // 先判断所有的是否都满足条件
              addonList.forEach((spec) => {
                if (spec.name === item.name) {
                }
              });
            });
          }
        }
      }


      if (data.changedStep.imprintMethod) {
        appState.updatePriceList();
        useUpdateView({
          isBlank: appState.getBlankValue,
          selectedProductSpecList: productSpecListState.getSelectedList,
          selectedSpecList: specState.getSelectedList,
          selectedAddonList: addonState.getSelectedList,
          selectedImprintMethodList: imprintMethodState.getSelectedList,
          priceList: appState.getCurrentPriceList
        })

        if (options.type === 'location') {
          // 创建新的
          imprintMethodState.create({
            location: options.value.name,
          })
        }
        else if (options.type === 'method') {
          imprintMethodState.create({
            location: options.value.location!.Name,
            method: options.value.value
          })
        }
      }

      if (options.callback) {
        options.callback(data);
      }
    }
  }))
}

export { showPopupPriceGroup }
